import { Activity } from "lucide-react";

/** Live "Who's Working on What" board — only In Progress tasks. */
export function LiveBoard({ live }) {
  return (
    <section
      data-testid="live-board"
      className="rounded-2xl border border-cyan-500/25 bg-white p-4 shadow-[0_1px_0_rgba(15,23,42,0.04)]"
    >
      <div className="flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan-500/70" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-cyan-500" />
        </span>
        <h2 className="font-display text-lg font-medium tracking-tight">
          Who&apos;s Working on What
        </h2>
        <span className="mono ml-auto text-[10px] uppercase tracking-wider text-slate-400">
          live
        </span>
      </div>

      {live.length === 0 ? (
        <p data-testid="live-board-empty" className="mt-3 text-sm text-slate-500">
          Nobody has a task in progress right now.
        </p>
      ) : (
        <ul className="mt-3 divide-y divide-slate-100">
          {live.map((person) => (
            <li
              key={person.id}
              data-testid={`live-person-${person.id}`}
              className="flex gap-3 py-2.5"
            >
              <span className="mono mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-full bg-cyan-500/10 text-[10px] text-cyan-700">
                {person.name
                  .split(" ")
                  .map((part) => part[0])
                  .slice(0, 2)
                  .join("")}
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-slate-900">{person.name}</p>
                {person.tasks.map((task) => (
                  <p key={task.id} className="flex items-center gap-1.5 text-[12.5px] text-slate-600">
                    <Activity size={11} className="shrink-0 text-cyan-600" />
                    <span className="truncate">{task.name}</span>
                  </p>
                ))}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
